import type { KeyboardEvent } from 'react';

type ClickableProps = {
  onClick: () => void;
  role: 'button';
  tabIndex: 0;
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => void;
};

// Spreadable props that turn a non-button element into a keyboard-activatable
// button (Enter/Space), keeping mouse and keyboard behaviour in sync. Returns
// nothing when there is no handler, so the element stays inert.
export function clickableProps(onActivate?: () => void): Partial<ClickableProps> {
  if (!onActivate) return {};
  return {
    onClick: onActivate,
    role: 'button',
    tabIndex: 0,
    onKeyDown: (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate();
      }
    },
  };
}
